module.exports = __webpack_public_path__ + "static/media/order.3756d67e.svg";